module.exports = __webpack_public_path__ + "img/symbol_12.dc6bc15b.png";